<template>
  <div>
    <h2>这是<em>Test</em>画面！</h2>

    <uploadFile v-if="uploadFileReloadFlag" ref="uploadCardFile_1" 
      :uploadFile="{
        locationCode: locationCode,
        uploadBtnDisplayFlag: uploadBtnDisplayFlag,
      }">
    </uploadFile>


    <el-button type="submit" @click="upload">提交表单</el-button>

    <el-button type="success" @click="changeUploadFileStatus">编辑/保存</el-button>

    <el-button type="success" @click="getLocationCode">获取LocationCode</el-button>

  </div>
</template>

<script>
import uploadFile from "../components/Common/UploadAttachment.vue";
import { build20Id } from "../utils/buildId.js";

  export default {
    components: {
      uploadFile
    },
    data() {
      return {
        // 上传按钮控件是否显示按钮（重新加载用）
        uploadFileReloadFlag:true,
        // 上传按钮显示标志
        uploadBtnDisplayFlag:false,
        // 位置关联Code
        locationCode:1,
      }
    },
    methods: {
      // 附件提交
      async upload() {
        // 风险分析1
        await this.$refs.uploadCardFile_1.submitUploadFile();
      },

      // 改变上传文件的状态
      changeUploadFileStatus(){
        // console.log(this.uploadFile.uploadBtnDisplayFlag) //= !this.uploadFile.uploadBtnDisplayFlag;
        this.uploadBtnDisplayFlag = !this.uploadBtnDisplayFlag ;
        this.reloadUploadFile();
      },

      // 重新加载上传附件控件
      async reloadUploadFile(){
        this.uploadFileReloadFlag = false;
        await this.$nextTick();
        this.uploadFileReloadFlag = true;
      },
      // 获取LocationCode方法
      getLocationCode(){
        alert("LocationCode:" + build20Id());
      }
    },
    mounted() {
    }

  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/test.vue